// extracted by mini-css-extract-plugin
export default {"top-to-btm":"buttonToTop_top-to-btm__ccbvA","icon-position":"buttonToTop_icon-position__0tkOT","icon-style":"buttonToTop_icon-style__OlbWs","movebtn":"buttonToTop_movebtn__VLeaB"};